<template>
  <editor :id="id" default-tab="list_json_import" :tabs="tabs"></editor>
</template>

<script>
import Editor from '@/components/Editor'
import Basic from './list_data/JsonImport'

export default {
  props: ['id'],
  components: {
    Editor
  },
  data () {
    return {
      tabs: [
        {title: "List json import", name: "list_json_import", component: Basic},
      ]
    }
  }
}
</script>
